<!--
 * @Author: yuanjianlong
 * @Description: 面包屑
 * @Date: 2022-02-24 14:16:18
 * @LastEditTime: 2022-03-10 18:45:48
 * @FilePath: /teacher-h5/src/components/ComBreadcrumb.vue
-->
<template>
  <a-breadcrumb>
    <a-breadcrumb-item v-for="(item, index) in breadcrumbData" :key="index">
      <router-link :to="{name: item.name}">
        {{ item.title }}
      </router-link>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
export default {
  name: 'ComBreadcrumb',

  data() {
    return {
      breadcrumbData: []
    }
  },

  watch: {
    $route: 'handleRouteChange'
  },

  created() {
    this.handleRouteChange()
  },

  methods: {
    handleRouteChange(to, from) {
      const { matched } = this.$route

      if (matched?.length > 0) {
        this.breadcrumbData = []

        matched.forEach(item => {
          if (item?.meta?.title) {
            this.breadcrumbData.push({
              name: item.name,
              title: item.meta.title
            })
          }
        })
      }
    }
  }
}
</script>